var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1597 5.1842L18.2326 1.21844C17.667 0.452194 16.7713 0 15.8189 0H6.18101C5.22864 0 4.33285 0.452195 3.76729 1.21844L0.840184 5.1842C0.0464547 6.25957 0.0598719 7.73033 0.873088 8.79105L8.61913 18.8946C9.81994 20.4609 12.18 20.4609 13.3808 18.8946L21.1268 8.79105C21.94 7.73033 21.9534 6.25957 21.1597 5.1842ZM2.72383 6L5.37644 2.40615C5.56496 2.15073 5.86355 2 6.18101 2H15.8189C16.1363 2 16.4349 2.15073 16.6235 2.40615L19.2761 6H2.72383ZM2.78676 8L10.2063 17.6777C10.6066 18.1998 11.3933 18.1998 11.7936 17.6777L19.2131 8H2.78676Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/Product_Icon.3cb96935704cb230adfcad45a90704ee.svg";
export { ForwardRef as ReactComponent };